import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["id", "open", "onClose", "initialFocus", "__demoMode"],
    _excluded2 = ["id"],
    _excluded3 = ["id"],
    _excluded4 = ["id"],
    _excluded5 = ["id"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import g, { createContext as fe, createRef as ge, useCallback as X, useContext as j, useEffect as I, useMemo as R, useReducer as Te, useRef as K, useState as ce } from "react";
import { match as w } from '../../utils/match.js';
import { forwardRefWithAs as v, render as O, Features as V } from '../../utils/render.js';
import { useSyncRefs as b } from '../../hooks/use-sync-refs.js';
import { Keys as De } from '../keyboard.js';
import { isDisabledReactIssue7711 as me } from '../../utils/bugs.js';
import { useId as h } from '../../hooks/use-id.js';
import { FocusTrap as L } from '../../components/focus-trap/focus-trap.js';
import { Portal as B } from '../../components/portal/portal.js';
import { ForcePortalRoot as G } from '../../internal/portal-force-root.js';
import { Description as Pe, useDescriptions as ye } from '../description/description.js';
import { useOpenClosed as Ee, State as _ } from '../../internal/open-closed.js';
import { useServerHandoffComplete as Ae } from '../../hooks/use-server-handoff-complete.js';
import { StackProvider as Re, StackMessage as q } from '../../internal/stack-context.js';
import { useOutsideClick as Ce } from '../../hooks/use-outside-click.js';
import { useOwnerDocument as ve } from '../../hooks/use-owner.js';
import { useEventListener as Oe } from '../../hooks/use-event-listener.js';
import { Hidden as be, Features as he } from '../../internal/hidden.js';
import { useEvent as C } from '../../hooks/use-event.js';
import { useDocumentOverflowLockedEffect as Le } from '../../hooks/document-overflow/use-document-overflow.js';
import { useInert as z } from '../../hooks/use-inert.js';

var Se = function (o) {
  return o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o;
}(Se || {}),
    Fe = function (e) {
  return e[e.SetTitleId = 0] = "SetTitleId", e;
}(Fe || {});

var ke = _defineProperty({}, 0, function _(t, e) {
  return t.titleId === e.id ? t : _objectSpread(_objectSpread({}, t), {}, {
    titleId: e.id
  });
}),
    M = fe(null);

M.displayName = "DialogContext";

function S(t) {
  var e = j(M);

  if (e === null) {
    var o = new Error("<".concat(t, " /> is missing a parent <Dialog /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(o, S), o;
  }

  return e;
}

function xe(t, e) {
  var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return [document.body];
  };
  Le(t, e, function (s) {
    var n;
    return {
      containers: [].concat(_toConsumableArray((n = s.containers) != null ? n : []), [o])
    };
  });
}

function _e(t, e) {
  return w(e.type, ke, t, e);
}

var Me = "div",
    He = V.RenderStrategy | V.Static;

function Ie(t, e) {
  var o = h(),
      _t$id = t.id,
      s = _t$id === void 0 ? "headlessui-dialog-".concat(o) : _t$id,
      n = t.open,
      l = t.onClose,
      d = t.initialFocus,
      _t$__demoMode = t.__demoMode,
      c = _t$__demoMode === void 0 ? !1 : _t$__demoMode,
      D = _objectWithoutProperties(t, _excluded),
      _ce = ce(0),
      _ce2 = _slicedToArray(_ce, 2),
      P = _ce2[0],
      F = _ce2[1],
      i = Ee();

  n === void 0 && i !== null && (n = (i & _.Open) === _.Open);
  var m = K(null),
      Q = b(m, e),
      y = K(null),
      p = ve(m),
      U = t.hasOwnProperty("open") || i !== null,
      N = t.hasOwnProperty("onClose");
  if (!U && !N) throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
  if (!U) throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
  if (!N) throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
  if (typeof n != "boolean") throw new Error("You provided an `open` prop to the `Dialog`, but the value is not a boolean. Received: ".concat(n));
  if (typeof l != "function") throw new Error("You provided an `onClose` prop to the `Dialog`, but the value is not a function. Received: ".concat(l));

  var u = n ? 0 : 1,
      _Te = Te(_e, {
    titleId: null,
    descriptionId: null,
    panelRef: ge()
  }),
      _Te2 = _slicedToArray(_Te, 2),
      E = _Te2[0],
      Z = _Te2[1],
      A = C(function () {
    return l(!1);
  }),
      Y = C(function (r) {
    return Z({
      type: 0,
      id: r
    });
  }),
      k = Ae() ? c ? !1 : u === 0 : !1,
      x = P > 1,
      $ = j(M) !== null,
      ee = x ? "parent" : "leaf",
      W = i !== null ? (i & _.Closing) === _.Closing : !1,
      te = function () {
    return $ || W ? !1 : k;
  }(),
      oe = X(function () {
    var r, f;
    return (f = Array.from((r = p == null ? void 0 : p.querySelectorAll("body > *")) != null ? r : []).find(function (a) {
      return a.id === "headlessui-portal-root" ? !1 : a.contains(y.current) && a instanceof HTMLElement;
    })) != null ? f : null;
  }, [y]);

  z(oe, te);

  var re = function () {
    return x ? !0 : k;
  }(),
      ne = X(function () {
    var r, f;
    return (f = Array.from((r = p == null ? void 0 : p.querySelectorAll("[data-headlessui-portal]")) != null ? r : []).find(function (a) {
      return a.contains(y.current) && a instanceof HTMLElement;
    })) != null ? f : null;
  }, [y]);

  z(ne, re);

  var H = C(function () {
    var f, a;
    return [].concat(_toConsumableArray(Array.from((f = p == null ? void 0 : p.querySelectorAll("html > *, body > *, [data-headlessui-portal]")) != null ? f : []).filter(function (T) {
      return !(T === document.body || T === document.head || !(T instanceof HTMLElement) || T.contains(y.current) || E.panelRef.current && T.contains(E.panelRef.current));
    })), [(a = E.panelRef.current) != null ? a : m.current]);
  }),
      le = function () {
    return !(!k || x);
  }();

  Ce(function () {
    return H();
  }, A, le);

  var ae = function () {
    return !(x || u !== 0);
  }();

  Oe(p == null ? void 0 : p.defaultView, "keydown", function (r) {
    ae && (r.defaultPrevented || r.key === De.Escape && (r.preventDefault(), r.stopPropagation(), A()));
  });

  var ie = function () {
    return !(W || u !== 0 || $);
  }();

  xe(p, ie, H), I(function () {
    if (u !== 0 || !m.current) return;
    var r = new ResizeObserver(function (f) {
      var _iterator = _createForOfIteratorHelper(f),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var a = _step.value;
          var T = a.target.getBoundingClientRect();
          T.x === 0 && T.y === 0 && T.width === 0 && T.height === 0 && A();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
    return r.observe(m.current), function () {
      return r.disconnect();
    };
  }, [u, m, A]);

  var _ye = ye(),
      _ye2 = _slicedToArray(_ye, 2),
      se = _ye2[0],
      pe = _ye2[1],
      de = R(function () {
    return [{
      dialogState: u,
      close: A,
      setTitleId: Y
    }, E];
  }, [u, E, A, Y]),
      J = R(function () {
    return {
      open: u === 0
    };
  }, [u]),
      ue = {
    ref: Q,
    id: s,
    role: "dialog",
    "aria-modal": u === 0 ? !0 : void 0,
    "aria-labelledby": E.titleId,
    "aria-describedby": se
  };

  return g.createElement(Re, {
    type: "Dialog",
    enabled: u === 0,
    element: m,
    onUpdate: C(function (r, f) {
      var _w;

      f === "Dialog" && w(r, (_w = {}, _defineProperty(_w, q.Add, function () {
        return F(function (a) {
          return a + 1;
        });
      }), _defineProperty(_w, q.Remove, function () {
        return F(function (a) {
          return a - 1;
        });
      }), _w));
    })
  }, g.createElement(G, {
    force: !0
  }, g.createElement(B, null, g.createElement(M.Provider, {
    value: de
  }, g.createElement(B.Group, {
    target: m
  }, g.createElement(G, {
    force: !1
  }, g.createElement(pe, {
    slot: J,
    name: "Dialog.Description"
  }, g.createElement(L, {
    initialFocus: d,
    containers: H,
    features: k ? w(ee, {
      parent: L.features.RestoreFocus,
      leaf: L.features.All & ~L.features.FocusLock
    }) : L.features.None
  }, O({
    ourProps: ue,
    theirProps: D,
    slot: J,
    defaultTag: Me,
    features: He,
    visible: u === 0,
    name: "Dialog"
  })))))))), g.createElement(be, {
    features: he.Hidden,
    ref: y
  }));
}

var we = "div";

function Be(t, e) {
  var o = h(),
      _t$id2 = t.id,
      s = _t$id2 === void 0 ? "headlessui-dialog-overlay-".concat(o) : _t$id2,
      n = _objectWithoutProperties(t, _excluded2),
      _S = S("Dialog.Overlay"),
      _S2 = _slicedToArray(_S, 1),
      _S2$ = _S2[0],
      l = _S2$.dialogState,
      d = _S2$.close,
      c = b(e),
      D = C(function (i) {
    if (i.target === i.currentTarget) {
      if (me(i.currentTarget)) return i.preventDefault();
      i.preventDefault(), i.stopPropagation(), d();
    }
  }),
      P = R(function () {
    return {
      open: l === 0
    };
  }, [l]);

  return O({
    ourProps: {
      ref: c,
      id: s,
      "aria-hidden": !0,
      onClick: D
    },
    theirProps: n,
    slot: P,
    defaultTag: we,
    name: "Dialog.Overlay"
  });
}

var Ge = "div";

function Ue(t, e) {
  var o = h(),
      _t$id3 = t.id,
      s = _t$id3 === void 0 ? "headlessui-dialog-backdrop-".concat(o) : _t$id3,
      n = _objectWithoutProperties(t, _excluded3),
      _S3 = S("Dialog.Backdrop"),
      _S4 = _slicedToArray(_S3, 2),
      l = _S4[0].dialogState,
      d = _S4[1],
      c = b(e);

  I(function () {
    if (d.panelRef.current === null) throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.");
  }, [d.panelRef]);
  var D = R(function () {
    return {
      open: l === 0
    };
  }, [l]);
  return g.createElement(G, {
    force: !0
  }, g.createElement(B, null, O({
    ourProps: {
      ref: c,
      id: s,
      "aria-hidden": !0
    },
    theirProps: n,
    slot: D,
    defaultTag: Ge,
    name: "Dialog.Backdrop"
  })));
}

var Ne = "div";

function Ye(t, e) {
  var o = h(),
      _t$id4 = t.id,
      s = _t$id4 === void 0 ? "headlessui-dialog-panel-".concat(o) : _t$id4,
      n = _objectWithoutProperties(t, _excluded4),
      _S5 = S("Dialog.Panel"),
      _S6 = _slicedToArray(_S5, 2),
      l = _S6[0].dialogState,
      d = _S6[1],
      c = b(e, d.panelRef),
      D = R(function () {
    return {
      open: l === 0
    };
  }, [l]),
      P = C(function (i) {
    i.stopPropagation();
  });

  return O({
    ourProps: {
      ref: c,
      id: s,
      onClick: P
    },
    theirProps: n,
    slot: D,
    defaultTag: Ne,
    name: "Dialog.Panel"
  });
}

var $e = "h2";

function We(t, e) {
  var o = h(),
      _t$id5 = t.id,
      s = _t$id5 === void 0 ? "headlessui-dialog-title-".concat(o) : _t$id5,
      n = _objectWithoutProperties(t, _excluded5),
      _S7 = S("Dialog.Title"),
      _S8 = _slicedToArray(_S7, 1),
      _S8$ = _S8[0],
      l = _S8$.dialogState,
      d = _S8$.setTitleId,
      c = b(e);

  I(function () {
    return d(s), function () {
      return d(null);
    };
  }, [s, d]);
  var D = R(function () {
    return {
      open: l === 0
    };
  }, [l]);
  return O({
    ourProps: {
      ref: c,
      id: s
    },
    theirProps: n,
    slot: D,
    defaultTag: $e,
    name: "Dialog.Title"
  });
}

var Je = v(Ie),
    Xe = v(Ue),
    je = v(Ye),
    Ke = v(Be),
    Ve = v(We),
    St = Object.assign(Je, {
  Backdrop: Xe,
  Panel: je,
  Overlay: Ke,
  Title: Ve,
  Description: Pe
});
export { St as Dialog };